<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else esignNoteFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="esignNoteFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #esignNoteFlexColumnTemplate>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else esignNoteMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="esignNoteMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #esignNoteMainFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="showSpinner">
    <div class="display-text normal-paragraph-spacing" style="text-align: center">
      <mat-spinner color="accent" diameter="64"></mat-spinner>
    </div>
  </div>
  <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="!showSpinner">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else esignNoteHeaderFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="esignNoteHeaderFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column" *ngIf="!esignLegalTextFound">
            <div *ngIf="isBrowserIE; else esignNoteNoRecordsFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="esignNoteNoRecordsFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column" *ngIf="esignLegalTextFound">
            <div *ngIf="isBrowserIE; else esignNoteStepperFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="esignNoteStepperFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #esignNoteHeaderFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
      <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
        <b>{{ userFullName }}</b>
      </span>
    </div>
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@esign-note.list.participant-id.label">esign-note.list.participant-id.label</span>:&nbsp;{{ participantIdString }}</b>
    </div>
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@esign-note.list.note-id.label">esign-note.list.note-id.label</span>:&nbsp;{{ noteIdString }}</b>
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px"></div>
  </div>
</ng-template>

<ng-template #esignNoteNoRecordsFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text">
      <i><span i18n="@@esign-note.list.no-records-text">esign-note.list.no-records-text</span></i>
    </div>
  </div>
</ng-template>

<ng-template #esignNoteStepperFlexColumnTemplate>
  <div class="normal-paragraph-pre-spacing">
    <span class="display-text normal-paragraph-spacing" i18n="@@esign-note.stepper.statement.1">esign-note.stepper.statement.1</span>
    <ul>
      <li>
        <span class="display-text normal-paragraph-spacing" i18n="@@esign-note.stepper.statement.1a">esign-note.stepper.statement.1a</span>
      </li>
      <li>
        <span class="display-text normal-paragraph-spacing" i18n="@@esign-note.stepper.statement.1b">esign-note.stepper.statement.1b</span>
      </li>
      <li>
        <span class="display-text normal-paragraph-spacing" i18n="@@esign-note.stepper.statement.1c">esign-note.stepper.statement.1c</span>
      </li>
    </ul>
  </div>
  <mat-vertical-stepper [linear]="true" #esignNoteStepper>
    <ng-template matStepperIcon="edit"> <mat-icon>done</mat-icon> </ng-template>
    <ng-template matStepperIcon="done"> <mat-icon>done</mat-icon> </ng-template>
    <mat-step [completed]="step1Complete" [editable]="step1Editable">
      <ng-template matStepLabel i18n="@@esign-note.stepper.step1.label">esign-note.stepper.step1.label</ng-template>
      <div class="display-text primary-dark-color-important normal-paragraph-spacing">
        <b><span i18n="@@esign-note.stepper.step1.title">esign-note.stepper.step1.title</span></b>
      </div>
      <div>
        <button
          mat-flat-button
          color="primary"
          (click)="viewDisclosures()"
          i18n="@@esign-note.stepper.step1.view-button.label"
          [disabled]="loanCode === null"
        >
          esign-note.stepper.step1.view-button.label
        </button>
      </div>
      <div class="small-display-text warning-color-important normal-paragraph-pre-spacing">
        <span i18n="@@esign-note.stepper.step1.disclosure.statement">esign-note.stepper.step1.disclosure.statement</span>
      </div>
      <div style="margin-top: 24px;">
        <button mat-stroked-button color="primary" matStepperNext [disabled]="!step1Complete">
          <span i18n="@@esign-note.stepper.next-button.label">esign-note.stepper.next-button.label</span>&nbsp;2
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
    </mat-step>
    <mat-step [completed]="step2Complete" [editable]="step2Editable">
      <ng-template matStepLabel i18n="@@esign-note.stepper.step2.label">esign-note.stepper.step2.label</ng-template>
      <div class="scrollable-list" *ngIf="!esignProcessed">
        <div class="display-text normal-paragraph-spacing" *ngFor="let listItem of this.esignLegalTextList">{{ listItem.legalText }}</div>
      </div>
      <div
        class="display-text primary-dark-color-important normal-paragraph-spacing"
        *ngIf="!step2Complete && getIpAddressValue() !== null && !esignProcessed"
      >
        <b><span i18n="@@esign-note.stepper.step2.title">esign-note.stepper.step2.title</span></b>
      </div>
      <div
        class="display-text warning-color-important normal-paragraph-spacing"
        *ngIf="!step2Complete && getIpAddressValue() === null && !esignProcessed"
      >
        <b><span i18n="@@esign-note.stepper.step2.no-ip-address.error">esign-note.stepper.step2.no-ip-address.error</span></b>
      </div>
      <div *ngIf="!step2Complete && !esignProcessed">
        <button
          mat-flat-button
          color="primary"
          (click)="agreeToESign()"
          [disabled]="step2Complete || getIpAddressValue() === null"
          i18n="@@esign-note.stepper.step2.agree-button.label"
        >
          esign-note.stepper.step2.agree-button.label</button
        >&nbsp;&nbsp;<button
          mat-stroked-button
          color="primary"
          (click)="cancelESign()"
          [disabled]="step2Complete"
          i18n="@@esign-note.stepper.step2.cancel-button.label"
        >
          esign-note.stepper.step2.cancel-button.label
        </button>
      </div>
      <div style="margin-top: 24px;" *ngIf="!step2Complete && !esignProcessed">
        <button mat-stroked-button color="primary" matStepperPrevious [disabled]="!step1Complete || step2Complete">
          <mat-icon>keyboard_arrow_up</mat-icon>
          <span i18n="@@esign-note.stepper.previous-button.label">esign-note.stepper.previous-button.label</span>&nbsp;1
        </button>
      </div>
      <div class="display-text normal-paragraph-spacing" *ngIf="showEsignSpinner">
        <mat-spinner color="accent" diameter="32"></mat-spinner>
      </div>
      <div class="display-text primary-dark-color-important normal-paragraph-spacing" *ngIf="showEsignSuccess && esignProcessed">
        <b><span i18n="@@esign-note.stepper.step2.esign.success.text.1">esign-note.stepper.step2.esign.success.text.1</span></b>
      </div>
      <div class="display-text normal-paragraph-spacing" *ngIf="showEsignSuccess && esignProcessed">
        <span i18n="@@esign-note.stepper.step2.esign.success.text.2">esign-note.stepper.step2.esign.success.text.2</span>
      </div>
      <div style="margin-top: 24px;" *ngIf="showEsignSuccess && esignProcessed">
        <button
          mat-stroked-button
          color="primary"
          (click)="viewSignedContract()"
          [disabled]="loanCode === null"
          i18n="@@sign-note.stepper.step2.esign.view-contact-button.label"
        >
          sign-note.stepper.step2.esign.view-contact-button.label</button
        >&nbsp;&nbsp;<button
          mat-flat-button
          color="primary"
          (click)="esignSuccess()"
          i18n="@@esign-note.stepper.step2.esign.success-button.label"
        >
          esign-note.stepper.step2.esign.success-button.label</button
        >&nbsp;&nbsp;<button
          mat-flat-button
          color="primary"
          (click)="openAutoPay()"
          i18n="@@esign-note.stepper.step2.esign.autopay-button.label"
        >
          esign-note.stepper.step2.esign.autopay-button.label
        </button>
      </div>
      <div class="display-text warning-color-important normal-paragraph-spacing" *ngIf="showEsignFailure && esignProcessed">
        <b><span i18n="@@esign-note.stepper.step2.esign.failure.text.1">esign-note.stepper.step2.esign.failure.text.1</span></b>
      </div>
      <div class="display-text normal-paragraph-spacing" *ngIf="showEsignFailure && esignProcessed">
        <span i18n="@@esign-note.stepper.step2.esign.failure.text.2">esign-note.stepper.step2.esign.failure.text.2</span>
      </div>
      <div style="margin-top: 24px;" *ngIf="showEsignFailure && esignProcessed">
        <button mat-flat-button color="primary" (click)="esignFailure()" i18n="@@esign-note.stepper.step2.esign.failure-button.label">
          esign-note.stepper.step2.esign.failure-button.label
        </button>
      </div>
    </mat-step>
  </mat-vertical-stepper>
</ng-template>
